import {$http} from '@/config/api/axios'
import { Message } from 'element-ui';
export default {
    namespaced: true,
    state: {
        globalTheme: localStorage.getItem('echartsTheme') || 'theme1',
        freshName:'',
        keepAlive: ['controller','controller-en'], // 需要缓存的路由名称
        allCollect:[], // 所有导航
        collect:[], // 已收藏的导航
        activeNav:-1, // 高亮导航索引
        navStable:false, // 左侧导航是否固定标识
        guideShow:false, // 是否显示引导页
        acrossMap:new Map(),
    },
    getters: {
        freshName: state => {
            return state.freshName
        },
        keepAlive: state => {
            return state.keepAlive
        },
        navStable: state => {
            return state.navStable
        },
        allCollect: state => {
            return state.allCollect
        },
        collect: state => {
            return state.collect
        },
        activeNav: state => {
            return state.activeNav
        },
        globalTheme: state => {
            return state.globalTheme
        },
        guideShow: state => {
            return state.guideShow
        },
        acrossMap: state => {
            return state.acrossMap
        }
    },
    mutations: {
        SET_FRESH_NAME:(state,str)=>{
            state.freshName = str
        },
        SET_KEEP_ALIVE: (state, arr) => {
            state.keepAlive = arr
        },
        SET_NAV_STABLE: (state,boolean) => {
            state.navStable = boolean
        },
        SET_ALL_COLLECT: (state,arr) => {
            state.allCollect = arr
        },
        SET_ACTIVE_NAV: (state,number) => {
            state.activeNav = number
        },
        SET_GLOBAL_THEME: (state,globalTheme) => {
            state.globalTheme = globalTheme
        },
        RESET_STATE: (state) => {
            state = Object.assign(state, resetState())
        },
        SET_GUIDE_SHOW: (state,boolean) => {
            state.guideShow = boolean
        },
        SET_ACCROSS_MAP: (state,ops) => {
            state.acrossMap.set(ops.path,ops.options)
        }
    },
    actions:{
        async get_Allroutes({commit, state}){
            let arrAll = [];
            // await new Promise((resolve,reject)=>{
            //     setTimeout(()=>{
            //         arrAll = [
            //             {
            //                 title:'数据展示',
            //                 children:[
            //                     // {id:4633242,path:'static3',moduleName:'分区警告ex',collect:false},
            //                     // {id:452342,path:'static4',moduleName:'DMA分析ex',collect:false},
            //                     // {id:468996,path:'static5',moduleName:'Echarts (demo)',collect:false,iconName:'icon-zhanghu'},
            //                     // {id:544542,path:'clientmanage',moduleName:'客户管理(demo)',moduleEnName:'demo',collect:false},
            //                     {id:44245,path:'trafficAnalysis',moduleName:'流量分析',moduleEnName:'lyfx',collect:false},
            //                     {id:12342135,path:'deviceAnalysis',moduleName:'设备分析',moduleEnName:'deviceana',collect:false},
            //                 ]
            //             }
            //         ]
            //         resolve(arrAll)
            //     },200)
            // })
            await $http("get", "module/listSelfModules", {}).then((res) => {
                if(res.status == 'SUCCESS'){
                    arrAll.push(...res.data);
                }else{
                    Message.error(localStorage.getItem('language-type') === 'zh-CN'?res.message:res.enMessage);
                }
            });
            state.collect = [];
            arrAll.forEach(item=>{ // 添加已收藏的list
                item.children.forEach(ele => {
                    if(ele.collect){
                        state.collect.push(ele)
                    }
                })
            })
            commit('SET_ALL_COLLECT',arrAll)
            return arrAll
        },
    }
}
function resetState(){
    return {
        navStable:false
    }
}